namespace $ {
	/** Retry only an exhausted key search, before native allocation has any Units. */
	export class $shm_hitalama_map_widget_entity_table2_allocation extends $mol_object {
		@ $mol_action
		static land_grab( preset: $giper_baza_rank_preset, context: $ = this.$ ): $giper_baza_land {
			let exhausted: Error | null = null
			for( let attempt = 0; attempt < 3; ++attempt ) {
				const land = $mol_error_fence< $giper_baza_land | null >(
					()=> context.$giper_baza_glob.land_grab( preset ),
					error=> {
						if( error.message !== 'Too long key generation' ) return error
						exhausted = error
						return null
					},
				)
				if( land ) return land
			}
			return $mol_fail_hidden( exhausted! )
		}
	}
}
